import {
  GET_CHECKOUT,
  SET_CHECKOUT,
  REMOVE_CHECKOUT,
  CHECKOUT_ERROR,
} from "./types";
import { getCheckout } from "../../commons/functions/generalFunctions";

export const getCheckoutState = () => async (dispatch) => {
  try {
    const checkout = getCheckout();
    dispatch({
      type: GET_CHECKOUT,
      payload: checkout,
    });
  } catch (error) {
    dispatch({
      type: CHECKOUT_ERROR,
      payload: error,
    });
  }
};

export const setCheckoutState = (checkout) => async (dispatch) => {
  try {
    localStorage.setItem(
      "checkout",
      JSON.stringify({
        ...checkout,
        cardInfo: {
          cardName: { value: "", error: "" },
          cardNumber: { value: "", error: "" },
          cardExpiryDate: { value: "", error: "" },
          cardCVV2: { value: "", error: "" },
        },
      })
    );
    dispatch({
      type: SET_CHECKOUT,
    });
  } catch (error) {
    dispatch({
      type: CHECKOUT_ERROR,
      payload: error,
    });
  }
};

export const removeCheckoutState = () => async (dispatch) => {
  try {
    localStorage.removeItem("checkout");
    dispatch({
      type: REMOVE_CHECKOUT,
    });
  } catch (error) {
    dispatch({
      type: CHECKOUT_ERROR,
      payload: error,
    });
  }
};
